/**
 * Обёртка фирменного глифа: до неё каждый вызов писал свой
 * dangerouslySetInnerHTML со span'ом. Строки глифов — наши собственные
 * константы из glyphs.ts (не пользовательский ввод), поэтому вставка разметкой
 * безопасна; централизованная обёртка держит это в одном месте.
 */
export function Glyph({ svg, class: cls }: { readonly svg: string; readonly class?: string }) {
  return (
    <span
      class={cls ? `glyph ${cls}` : 'glyph'}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}
